export class StringUtil {

    static displayCorrectContractNumber = (noContract: string) => {
        return noContract.replace(/-|_|\s/g, '').toUpperCase();
    }
}
